import { ReactComponent as CloseSvg } from "../../assets/icons/close.svg";
import { useLockBodyScroll } from "../../hooks/useLockBodyScroll";
import Modal from "../utils/Modal/Modal";
import {
  ModalContainer,
  CloseButton,
  ModalContent,
  ModalTitle,
  ButtonGroup,
  ConfirmButton,
  Row,
  CancelButton,
  Label,
} from "./DeleteFolderModal.styles";

const DeleteFolderModal = ({
  isOpen,
  onClose,
  onConfirm,
  selectedFolder,
  isLoading = false,
}) => {
  useLockBodyScroll(isOpen);

  const handleConfirm = () => {
    onConfirm();
  };

  const handleCancel = () => {
    if (!isLoading) {
      onClose();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      customOverlayStyles={{ zIndex: 3100 }}
    >
      <ModalContainer>
        <ModalContent>
          <Row>
            <ModalTitle>Delete Folder</ModalTitle>
            <CloseButton onClick={handleCancel}>
              <CloseSvg width={20} height={20} />
            </CloseButton>
          </Row>

          <Label style={{ margin: "1rem 0rem" }}>
            Are you sure you want to delete the folder{" "}
            <strong>{selectedFolder?.name ?? ""}</strong>?
          </Label>

          <ButtonGroup>
            <CancelButton onClick={handleCancel} disabled={isLoading}>
              Cancel
            </CancelButton>
            <ConfirmButton
              onClick={handleConfirm}
              $type="danger"
              disabled={isLoading}
            >
              {isLoading ? "Deleting..." : "Delete"}
            </ConfirmButton>
          </ButtonGroup>
        </ModalContent>
      </ModalContainer>
    </Modal>
  );
};

export default DeleteFolderModal;
